// extracted by mini-css-extract-plugin
export default {"input":"FormSelect_input__BNTkl","title":"FormSelect_title__ILzrC","selectWrap":"FormSelect_selectWrap__mWLCz"};